import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const Team = () => {
  const data = useStaticQuery(graphql`
    {
      contentfulTeam(id: { eq: "910886eb-3053-5a69-a7d4-27754602d2f3" }) {
        id
        person {
          image {
            gatsbyImageData(width: 120, height: 120, layout: FIXED)
          }
          email
          name
          shortBio {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  `)
  const team = data.contentfulTeam.person.map((person) => {
    var profilePic
    if (person.image !== null) {
      profilePic = (
        <GatsbyImage
          className="m-auto"
          image={person.image.gatsbyImageData}
          className="profile-pic"
        />
      )
    } else {
      profilePic = <div></div>
    }
    return (
      <div className="person">
        {profilePic}
        <div className="name-bio-container">
          <div className="name">{person.name}</div>
          <div
            className="bio"
            dangerouslySetInnerHTML={{
              __html: person.shortBio.childMarkdownRemark.html,
            }}
          ></div>
        </div>
      </div>
    )
  })
  return (
    <div className="team">
      <div className="team-text">{team}</div>

      <h2 className="reise-headline">Team</h2>
    </div>
  )
}

export default Team
